<template>
  <div>
    <b-modal
      :active.sync="isModalActive"
      :can-cancel="true"
      :on-cancel="closeModal"
    >
      <div class="modal-container rb">
        <div class="full-height">
          <div class="close bold" @click="closeModal">
            close
          </div>
          <div class="full-height">
            <slot name="modal-content"></slot>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "modalContainer",
  props: {
    isModalActive: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
      return true;
    }
  }
};
</script>
